import React from 'react'
import { useState } from 'react'
import moon from '../assets/images/moon.png'
import SkillsData from '../utils/SkillsData'
import { motion } from "framer-motion";

export default function Skills() {

    const [skillsData, setSkills] = useState(SkillsData)
    const [choose, setChoose] = useState('languages')

  return (
    <motion.div 
        className='skills next skl'
        initial={{ x: -300, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -300, opacity: 0 }}
        transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
        }}
    >
         {/* LEFT */}
         <div className="left">
            {/* IMAGE */}
            <div className="image">
                <div>
                    <img src={moon} />
                </div>
            </div>
            <ul className='choose-skill'>
                <li className={choose == 'languages' ? 'active' : ''} onClick={()=>setChoose('languages')}>
                    <img src={moon} />
                    <p>Languages</p>
                </li>
                <li className={choose == 'databases' ? 'active' : ''} onClick={()=>setChoose('databases')}>
                    <img src={moon} />
                    <p>Databases</p>
                </li>
                <li className={choose == 'framework' ? 'active' : ''} onClick={()=>setChoose('framework')}>
                    <img src={moon} />
                    <p>Frameworks & Libs</p>
                </li>
                <li className={choose == 'additional' ? 'active' : ''} onClick={()=>setChoose('additional')}>
                    <img src={moon} />
                    <p>Additional</p>
                </li>
            </ul>
            {/* TEXT */}
            <div className="text">
                <h1>Skills <span>.</span></h1>
                <div className="info">
                    <span class="material-symbols-outlined">maximize</span>
                    <p>Every great work begins with <br /> an even better story.</p>
                </div>
            </div>
        </div>
        {/* DETAILS */}
        <div className="details">
            {
                skillsData.map(card=>{
                    return card.type == choose && <div className="card" key={card.id}>
                                                    <img src={card.img} />
                                                    <p>{card.name}</p>
                                                </div>
                })
            }
        </div>
    </motion.div>
  )
}
